import { useTranslation } from 'next-i18next';
import styled from '@emotion/styled';

import Typography from '@components/_atoms/Typography';
import ProductAlarmLabel from '@components/_organism/service/ProductAlarmLabel';
import { AlarmProductType } from '@components/_templates/seller/SellerPromoteAlramContent/types';

import { TypoVariant } from '@constants/atoms';

import { gray } from '@styles/Colors';
import { Radius } from '@styles/Radius';

type Props = {
  readonly productList: AlarmProductType[];
  readonly handleClickReset: () => void;
  readonly onClose: (index: number) => void;
};

const Layout = styled.div``;
const TextContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;
const TableTitle = styled(Typography)``;
const DeleteAllButton = styled(Typography)``;
const ProductList = styled.div`
  padding: 16px;
  height: 274px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  border: 1px solid ${gray.gray4};
  border-radius: ${Radius.MEDIUM};

  overflow-y: auto;
`;

export default function ProductTable({ productList, handleClickReset, onClose }: Props) {
  const { t } = useTranslation('materialnoti');

  return (
    <Layout>
      <TextContainer>
        <TableTitle variant={TypoVariant.SH3}>{t('sale.title')}</TableTitle>
        <DeleteAllButton
          variant={TypoVariant.SH3}
          color={gray.gray5}
          style={{ cursor: 'pointer' }}
          onClick={handleClickReset}>
          {t('sale.reset-btn')}
        </DeleteAllButton>
      </TextContainer>
      <ProductList>
        {productList.length ? (
          productList?.map((product, index) => (
            <ProductAlarmLabel key={index} data={product} onClose={() => onClose(index)} />
          ))
        ) : (
          <EmptyProductAlarmList />
        )}
      </ProductList>
    </Layout>
  );
}

const EmptyLayout = styled.div`
  margin: auto;
`;

const EmptyProductAlarmList = () => {
  const { t } = useTranslation('materialnoti');
  return (
    <EmptyLayout>
      <Typography variant={TypoVariant.B3} color={gray.gray6}>
        {t('sale.empty')}
      </Typography>
    </EmptyLayout>
  );
};
